import moment from 'moment';
import { Mapper } from '@/db/Mapper';

import { usersCollection, profilesCollection, Timestamp } from '@/db/firestore';
import { UserModel, UserProfileModel, NotificationPreferences, NotificationTypes } from '@/models/user';
export class Users {
    public write(user: any) {
        const usrObj: any = {};
        Object.assign(usrObj, user);

        const thisUser: UserModel = {
            uid:                usrObj.uid,
            displayName:        (usrObj.displayName || 'User'),
            email:              usrObj.email,
            emailVerified:      usrObj.emailVerified,
            lastSeen:           Timestamp.now(),
            phoneNumber:        usrObj.phoneNumber,
            photoURL:           usrObj.photoURL,
        };

        if (thisUser.uid) { 
            usersCollection.doc(thisUser.uid).set(thisUser, { merge: true })
            .catch((e) => {
                console.error(e);
            });
        }
    }

    public getById(userId: string) {
        return usersCollection.doc(userId);
    }

    public async getProfileDataById(userId: string): Promise<UserProfileModel> {

        const query = await profilesCollection.where('uid', '==', userId).limit(1).get();
        const data = query.docs[0].data() as UserProfileModel;
        data.id = query.docs[0].id;

        if (!data.notificationPreferences) {
            // default notification prefs   
            data.notificationPreferences = this.createDefaultNotificationPreferences();
        }
        return data;
    }

    public getProfileDataReactive(userId: string) {
        return profilesCollection.where('uid', '==', userId);
    }

    public updateUserProfile(profile: UserProfileModel) {
        profile.lastupdatedAt = Timestamp.now();
        return profilesCollection.doc(profile.id).update(profile);
    }
    public async deleteUser(userId: string) {
        const deleteTime    = moment().add(60, 'minutes');
        const tsDT          = Timestamp.fromDate(deleteTime.toDate());

        try {
            const val = await profilesCollection.where('uid', '==', userId).get();
            val.forEach((doc) => {
                // tslint:disable-next-line: no-console
                doc.ref.update({ deleteScheduled: true, deleteSchAt: tsDT }).catch(e => console.error(e));
            });
        } catch (e) {
            // tslint:disable-next-line: no-console
            return console.error(e);
        }
    }

    private createDefaultNotificationPreferences(): NotificationPreferences {
        const model: NotificationPreferences = {
            dueDecks: [ NotificationTypes.email, NotificationTypes.sms],
            learningReminders: [ NotificationTypes.email, NotificationTypes.sms],
            optOutAll: false
        };

        return model;
    }
}
